import React, { FC } from "react";
import { Redirect } from "react-router-dom";

import { ROUTE_PATHS } from "../../types/RoutePaths";

const DashboardRedirect: FC = () => <Redirect to={ROUTE_PATHS.ADVERTISERS_LIST} />;

export default DashboardRedirect;
